import React, { useEffect } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export default function MultiButton(props) {
  const { multiButtonSelect, setMultiButtonSelect, label } = props;

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null && newAlignment !== undefined) {
      setMultiButtonSelect(newAlignment);
    }
  };

  useEffect(() => {
    setMultiButtonSelect && setMultiButtonSelect(multiButtonSelect || label[0]);
  }, []);

  return (
    <div className="multiButton">
      <ToggleButtonGroup
        value={multiButtonSelect}
        exclusive={true}
        onChange={handleAlignment}
        aria-label="text alignment"
      >
        {label?.map((item, index) => {
          return (
            <ToggleButton key={index} value={item} aria-label={item}>
              <span className="text-capitalize">{item}</span>
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </div>
  );
}
